dmx.mediumEditor.Button('imageLeft', {
    contentDefault: '<b>Left</b>',
    contentFA: '<i class="fa fa-align-left"></i>',
    action: 'float-left',
    aria: 'Align image left',

    init: function() {
        MediumEditor.extensions.button.prototype.init.call(this);
    },

    isAlreadyApplied: function(node) {
        return node.classList.contains('medium-editor-image-upload-left');
    },

    handleClick: function(event) {
        var container = MediumEditor.util.getTopBlockContainer(MediumEditor.selection.getSelectionStart(this.document));
        if (container.classList.contains('medium-editor-image-upload')) {
            container.classList.remove('medium-editor-image-upload-right','medium-editor-image-upload-center','medium-editor-image-upload-full');
            container.classList.add('medium-editor-image-upload-left');
        }
        this.updateToolbar();
    },

    updateToolbar: function() {
        var toolbar = this.base.getExtensionByName('image-toolbar');
        if (toolbar) {
            toolbar.checkState();
        }
    }
});
